/**
 * GridClassicLayout Component
 * Standard uniform grid layout for shop products
 */

import React from 'react';
import ProductCard from './ProductCard';
import './GridClassicLayout.css';

function GridClassicLayout({
  products,
  onProductClick,
  themeColors,
  formatPrice,
  productsPerRow = 4,
  cardStyle = 'standard',
  isNavigating = false,
  onAddToCart,
  renderAdPlacement,
  adInterval = 6,
}) {
  return (
    <div
      className="gcl-grid"
      style={{ '--gcl-columns': productsPerRow }}
    >
      {products.map((product, index) => (
        <React.Fragment key={product.id || product._id}>
          {/* Insert ad placement after every N products */}
          {renderAdPlacement && index > 0 && index % adInterval === 0 && (
            <div className="gcl-ad-slot">{renderAdPlacement(index)}</div>
          )}
          <ProductCard
            product={product}
            onClick={onProductClick}
            themeColors={themeColors}
            formatPrice={formatPrice}
            cardStyle={cardStyle}
            isNavigating={isNavigating}
            onAddToCart={onAddToCart}
          />
        </React.Fragment>
      ))}
    </div>
  );
}

export default GridClassicLayout;
